import React from 'react';
import { connect } from 'react-redux'
import StatsTableRow from '../components/StatsTableRow';
import Loading from './Loading';
import GradedSmiley from './GradedSmiley';
import { ajaxFeedbackFilter, ajaxFeedbackStatusFilter, secondsToDhms, getStarsJSX, setOtherFilter, setFeedbackStatus } from './redux/FeedbackRedux';

class StatsTable extends React.Component {

	handleClick(event) {
		var timeframe = event.target.id;
        var status = this.props.status;
        var ids = this.props.business_id??null;
        if(this.props.businesses){
            ids = [];
            for(var i in this.props.businesses){
                ids.push(this.props.businesses[i].business_id);
            }
        }
		this.props.dispatch(ajaxFeedbackFilter(timeframe, status, this.props.feedback_id, ids, this.props.page, this.props.total, this.props.query, this.props.other_filter, this.props.archive, this.props.department_ids??null, (this.props.region ? this.props.region.id : null), this.props.region_type??null));
	}

	handleStatusClick(event) {
		event.preventDefault();
		var timeframe = this.props.timeframe;
        var status = event.target.id;
        var ids = this.props.business_id??null;
        if(this.props.businesses){
            ids = [];
            for(var i in this.props.businesses){
                ids.push(this.props.businesses[i].business_id);
            }
        }
        this.props.dispatch(ajaxFeedbackStatusFilter(this.props.state, status));
	}

	handleOtherClick(event) {
		event.preventDefault();
		var other_filter = event.target.id;
        if (!other_filter) {
            var is_a_star = jQuery(event.target).hasClass("rating-star");
            if (is_a_star) {
                other_filter = "ratethisbiz";
            }
        }
        if (other_filter == "ratethisbiz_span") {
            other_filter = "ratethisbiz";
        }

        this.props.dispatch(setOtherFilter(other_filter));
        this.props.dispatch(setFeedbackStatus("All"));

		this.props.dispatch(ajaxFeedbackStatusFilter(
			this.props.state,
			"All",
			null,
			null,
			other_filter
		));
	}

	shouldComponentUpdate(nextProps, nextState)
	{
		if(this.props.loading && !nextProps.loading)
		{
			return true;
		}
		return false;
	}

	handleCollapseTable(){
		if(jQuery('#sortTable tbody').is(":hidden")){
			jQuery('body').find('#sortTable').show();
		} else {
			jQuery('body').find('#sortTable').hide();
		}
	}

	render () {
		if(this.props.totals.smiley_score >= 85){
			var color='#01de1c';
		  } else if(this.props.totals.smiley_score >= 70 && this.props.totals.smiley_score < 85){
			var color='#33f502';
		  } else if(this.props.totals.smiley_score >= 55 && this.props.totals.smiley_score < 70){
			var color='#8cc704';
		  } else if(this.props.totals.smiley_score >= 45 && this.props.totals.smiley_score < 55){
			var color='#888888';
		  } else if(this.props.totals.smiley_score >= 30 && this.props.totals.smiley_score < 45){
			var color='#ffcf08';
		  } else if(this.props.totals.smiley_score >= 15 && this.props.totals.smiley_score < 30){
			var color='#fe0100';
		  } else if(this.props.totals.smiley_score >= 0 && this.props.totals.smiley_score < 15){
			var color='#b30101';
		  }

		return (
<div className="col-md-12">
			<div className="card">
				<Loading location={'stats'} />
				<div className="title-row align-items-center">
						<div className="card-title tab">
							<h5 className="pl-3 pr-3">{ __('Breakdown') }</h5>
						</div>
						<div className="card-title ml-auto">
							<span className="btn btn-outline-secondary btn-sm" onClick={this.handleCollapseTable.bind(this)} >{ __('Collapse / Expand') }</span>
						</div>
				</div>
				<div className="card-body card-body-table pt-0 pb-0 border-top">
					<table className="table mb-0 table-sortable mt-0 pt-0" style={{marginTop:"0px!important"}} id="sortTable">
						<thead>
							{jQuery('body').width() > 1000 &&
								<tr>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								<th className="p-0 border-0"></th>
								</tr>
							}

							{/* Table Row */}
							<tr>
							{this.props.is_super_user &&
								<th>{ __('Business Group') }</th>
							}

								<th className="col-1" scope="col">{ __('Location') }</th>
								<th className="col-1" scope="col">{ __('Total Feedbacks') }</th>
								<th className="col-1" scope="col">{window.feedbackStatus.Open.label}</th>
								<th className="col-1" scope="col">{window.feedbackStatus.Pending.label}</th>
								<th className="col-1" scope="col">{window.feedbackStatus.Resolved.label}</th>
								<th className="col-1" scope="col">{window.feedbackStatus.RatingsOnly.label}</th>
								<th className="col-1" scope="col">{ __('Chats Requested') }</th>
								<th className="col-1" scope="col">{ __('Chats Started') }</th>
								<th className="col-1 smiley-rating" scope="col">{ __('Smiley Score') } 
									<i className="far fa-question-circle text-muted" data-toggle="tooltip" data-placement="top" data-title={ __("Your Smiley Score is the average of the smiley ratings selected by your customers when submitting Feedbacks. The scores range from 0% (very negative exerience) to 100% (very positive experience) and are color-coded as follows:") + "<img src='/img/smiley-scale.png' style='width:100%; border-radius: 5px;' />"}></i>
								</th>
								<th className="col-1" scope="col">{ __('Median Resp Time') }</th>
								<th className="col-1" scope="col">{__('Ratings')}</th>
							</tr>
						</thead>
						<tbody>

						{this.props.stats_table && this.props.stats_table.map((value, index) => {
							return (<StatsTableRow key={index} business={value} />);
						})}
					</tbody>
					<tfoot>
						{this.props.totals != null &&
							<tr className="table-total no-sort totals-row">
								<th className="total">All Locations</th>
								{this.props.is_super_user &&
									<th></th>
								}
								<th className="text-primary feedbacks" style={{ cursor: 'pointer' }} id="All" onClick={this.handleStatusClick.bind(this)}>{this.props.totals.open + this.props.totals.pending + this.props.totals.resolved}</th>
								<th className="text-primary open" style={{ cursor: 'pointer' }} id="Open" onClick={this.handleStatusClick.bind(this)}>{this.props.totals.open}</th>
								{this.props.totals.pending > 0 && this.props.op &&
									<th data-toggle="tooltip" data-placement="top" data-title={"Oldest Feedback From: " + this.props.op} className="text-primary pending" style={{ cursor: 'pointer' }} id={window.feedbackStatus.Pending.value} onClick={this.handleStatusClick.bind(this)}>{this.props.totals.pending} {this.props.totals.pending > 0 && <span className="chat-alert-message anim-pulse"><i className="fas fa-exclamation-triangle text-warning mr-1"></i></span>}</th>
								}
								{this.props.totals.pending < 1 &&
									<th className="text-primary" style={{ cursor: 'pointer' }} id={window.feedbackStatus.Pending.value} onClick={this.handleStatusClick.bind(this)}>{this.props.totals.pending} {this.props.totals.pending > 0 && <span className="chat-alert-message anim-pulse" id={window.feedbackStatus.Pending.value}><i className="fas fa-exclamation-triangle text-warning mr-1" id={window.feedbackStatus.Pending.value}></i></span>}</th>
								}
								<th className="text-primary resolved" style={{ cursor: 'pointer' }} id={window.feedbackStatus.Resolved.value} onClick={this.handleStatusClick.bind(this)}>{this.props.totals.resolved}</th>
								<th className="text-primary ratingsOnly" style={{ cursor: 'pointer' }} id={window.feedbackStatus.RatingsOnly.value} onClick={this.handleStatusClick.bind(this)}>{this.props.totals.ratingsOnly}</th>
								<th className="text-primary requested" style={{ cursor: 'pointer' }} id="chats_requested" onClick={this.handleOtherClick.bind(this)}>{this.props.totals.chats_requested}</th>
								<th className="text-primary" style={{cursor: 'pointer'}}><a className="started" id="chats_started" onClick={this.handleOtherClick.bind(this)}>{ this.props.totals.chats_started + ((this.props.totals.chats_requested != 0 && this.props.totals.chats_started <= this.props.totals.chats_requested) ? ( parseInt(this.props.totals.chats_started / this.props.totals.chats_requested * 100) != 0 ? " (" + parseInt(this.props.totals.chats_started / this.props.totals.chats_requested * 100) + "%)":"") : 0 ) }</a><small id="chats_waiting" onClick={this.handleOtherClick.bind(this)}><br/>({this.props.totals.chats_waiting} Still Open)</small></th>
								<th className="text-primary sent" style={{ cursor: 'pointer' }} id="links_sent" onClick={this.handleOtherClick.bind(this)}>{this.props.totals.links_sent}</th>
								<th className="sent" style={{cursor: 'default'}} id="links_clicked">{this.props.totals.links_clicked}</th>
								{this.props.totals.smiley_score != null &&
									<th className="d-flex" style={{'color':color, 'whiteSpace':'nowrap'}}>
										<GradedSmiley smiley_score={this.props.totals.smiley_score} /> {this.props.totals.smiley_score}  %
									</th>
								}
								{this.props.totals.smiley_score == null &&
									<th>
										No Data
									</th>
								}
								<th className="mdntime">{(this.props.totals.median_response_time ? this.props.totals.median_response_time.formatted : "No Data")}</th>
								{this.props.totals.avg_ratethisbiz &&
									<th className="avg_ratethisbiz">{this.props.totals.avg_ratethisbiz}<br/>{ getStarsJSX(this.props.totals.avg_ratethisbiz) }</th>
								}
								{!this.props.totals.avg_ratethisbiz &&
									<th className="avg_ratethisbiz">No Data</th>
								}
							</tr>
						}
					</tfoot>
				</table>
				</div>
			</div>
		</div>
        );
    }
}

function mapStateToProps(state) {
	return { state: state, is_super_user: state.is_super_user??null, loading: state.loading && state.loading_location == "stats",timeframe: state.timeframe, status: state.status, other: state.other_filter, totals: state.totals, stats_table: state.stats_table, op:state.oldest_pending, businesses:(state.businesses??null), feedback_id:state.selected_feedback, page:state.current_page, total:state.total_pages, query: state.query, other_filter: state.other_filter, archive:state.archive }
}

export default connect(mapStateToProps)(StatsTable);
